import { useEffect, useState } from "react";
import { Sword } from "lucide-react";
import { toast } from "sonner";
import api, { apiErr } from "@/lib/api";

export function RevengeWeekPanel() {
  const [ev, setEv] = useState(null);
  const [busy, setBusy] = useState(false);
  const load = () => api.get("/admin/revenge-week").then((r) => setEv(r.data)).catch(() => setEv(null));
  useEffect(() => { load(); }, []);
  const toggle = async (action) => {
    setBusy(true);
    try { const r = await api.post("/admin/revenge-week", { action }); setEv(r.data); toast.success(action === "start" ? "Revenge Week started — runs 7 days!" : "Revenge Week ended."); }
    catch (e) { toast.error(apiErr(e)); } finally { setBusy(false); }
  };
  const active = ev?.active;
  return (
    <div data-testid="revenge-week-panel" className="mb-6 border border-red-900/50 bg-gradient-to-br from-red-950/20 to-zinc-950 p-4 rounded-sm">
      <div className="flex items-center gap-2 mb-3">
        <Sword size={16} className="text-red-400" />
        <h3 className="font-cinzel text-red-300 uppercase tracking-widest text-sm">Revenge Week Event</h3>
      </div>
      <div className="flex flex-wrap items-center gap-3">
        <p className="text-sm text-zinc-500 flex-1 min-w-[220px]">
          {active ? <span className="text-red-300">Active</span> : "Inactive"} — for 7 days, players can instantly challenge anyone who beat them in the last week (no rank limit, no accept needed) for double salvage.
          {active && ev?.ends_at ? <span className="text-zinc-500"> Ends {new Date(ev.ends_at).toLocaleString()}.</span> : null}
        </p>
        {active ? (
          <button data-testid="revenge-week-stop" onClick={() => toggle("stop")} disabled={busy}
            className="px-5 py-2 border border-red-900/50 text-red-300 hover:border-red-500 font-cinzel uppercase tracking-wide text-sm rounded-sm disabled:opacity-50">End Revenge Week</button>
        ) : (
          <button data-testid="revenge-week-start" onClick={() => toggle("start")} disabled={busy}
            className="px-5 py-2 bg-red-600 text-white font-cinzel uppercase tracking-wide text-sm hover:bg-red-500 rounded-sm disabled:opacity-50">Start Revenge Week</button>
        )}
      </div>
    </div>
  );
}
